module.exports = __webpack_public_path__ + "static/media/01.3fe1e0d2.png";